import { ESGitlabAssociatedRepository } from '../../models/git-repository';
import { Action } from '../../../../ngrx/actions/unsafe-action';

export const CREATE = '[gitlab-associated-repository.actions] CREATE';
export const UPDATED = '[gitlab-associated-repository.actions] UPDATED GITLAB REPOSITORYS';
export const GET_INDEX = '[gitlab-associated-repository.actions] GET_INDEX';
export const GET_INDEX_COMPLETE = '[gitlab-associated-repository.actions] GET_INDEX_COMPLETE';
export const REMOVE = '[gitlab-associated-repository.actions] REMOVE';
export const GET_INDEX_FAIL = '[gitlab-associated-repository.actions] GET_INDEX_FAIL';

export class GetIndex implements Action {
  readonly type = GET_INDEX;
}

export class Updated implements Action {
  readonly type = UPDATED;

  constructor(public payload: ESGitlabAssociatedRepository) {}
}

export class GetIndexComplete implements Action {
  readonly type = GET_INDEX_COMPLETE;

  constructor(public payload: ESGitlabAssociatedRepository) {}
}

export class GetIndexFail implements Action {
  readonly type = GET_INDEX_FAIL;

  constructor(public payload?: any) {}
}

export class Remove implements Action {
  readonly type = REMOVE;

  constructor(public payload: { id: number }) {}
}

export class Create implements Action {
  readonly type = CREATE;

  constructor(public payload: { repositoryId: number | string; repositoryName: string; gitlabCompany: number }) {}
}

// prettier-ignore
export type Actions
  = GetIndex
  | Updated
  | GetIndexComplete
  | GetIndexFail
  | Remove
  | Create
  ;
